export default "__VITE_ASSET__CrEd7vph__"